import Transform from './Transform';
Transform.install = (Vue)=>{
    Vue.components(Transform.name,Transform)
}
export default Transform;
